import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler, Slides } from 'ionic-angular';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { SQLite } from '@ionic-native/sqlite';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { FCM } from '@ionic-native/fcm';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { DatePicker } from '@ionic-native/date-picker';

import { ProgressBarComponent } from '../components/progress-bar/progress-bar';

import { MyApp } from './app.component';

import { HttpClientModule } from "@angular/common/http";

/* Pages */
import { CardapioListaPage } from '../pages/cardapio-lista/cardapio-lista';
import { ProdutoPage } from '../pages/produto/produto';
import { HomePage } from '../pages/home/home';
import { FavoritosPage } from '../pages/favoritos/favoritos';
import { EventosPage } from '../pages/eventos/eventos';
import { EventoDetalhesPage } from '../pages/evento-detalhes/evento-detalhes';
import { OfertasPage } from '../pages/ofertas/ofertas'

/* Providers */
import { Autenticacao } from '../providers/autenticacao';
import { Cadastro } from '../providers/cadastro';
import { Componentes } from '../providers/componentes';
import { Cardapio } from '../providers/cardapio';
import { LocalStorageProvider } from '../providers/local-storage';
import { SqlStorageProvider } from '../providers/sql-storage';
import { EventosProvider } from '../providers/eventos';
import { ClubeHistoricoProvider } from '../providers/clube-historico';
import { ClubeProvider } from '../providers/clube';
import { ClubeResgatesProvider } from '../providers/clube-resgates';
import { FavoritosProvider } from '../providers/favoritos';
import { PushProvider } from '../providers/push';

/* Validators */
import { Validacao } from '../validators/validacao';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { Http, HttpModule } from '@angular/http';
import { IonicStorageModule, Storage } from '@ionic/storage';
import { TextMaskModule } from 'angular2-text-mask';
import { VinhosProvider } from '../providers/vinhos';

import { LazyLoadImageModule } from 'ng-lazyload-image';
import { SugestoesProvider } from '../providers/sugestoes';

let storage: Storage = new Storage(null);

export function getAuthHttp(http) {
  return new AuthHttp(new AuthConfig({
    headerPrefix: 'cggrill',
    noJwtError: true,
    globalHeaders: [{ 'Accept': 'application/json' }],
    tokenGetter: (() => storage.get('token')),
  }), http);
}

@NgModule({
  declarations: [
    MyApp,
    CardapioListaPage,
    ProdutoPage,
    HomePage,
    FavoritosPage,
    EventosPage,
    EventoDetalhesPage,
    OfertasPage,
    ProgressBarComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    LazyLoadImageModule,
    IonicModule.forRoot(MyApp, {
      platforms: {
        ios: {
          backButtonText: 'Voltar'
        }
      }
    }),
    IonicStorageModule.forRoot(),
    TextMaskModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    CardapioListaPage,
    ProdutoPage,
    HomePage,
    FavoritosPage,
    EventosPage,
    EventoDetalhesPage,
    OfertasPage,
  ],
  providers: [
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    Componentes,
    Autenticacao,
    Cadastro,
    Validacao,
    StatusBar,
    SplashScreen,
    BarcodeScanner,
    PhotoViewer,
    InAppBrowser,
    DatePicker,
    FCM,
    SQLite,
    Slides,
    Cardapio,
    LocalStorageProvider,
    SqlStorageProvider,
    {
      provide: AuthHttp,
      useFactory: getAuthHttp,
      deps: [Http]
    },
    EventosProvider,
    ClubeProvider,
    ClubeHistoricoProvider,
    ClubeResgatesProvider,
    FavoritosProvider,
    PushProvider,
    VinhosProvider,
    SugestoesProvider
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts